import { createContext, useContext } from 'react';
import { defaultLocale } from './index';

export interface LocaleContextValue {
    /** The locale in force ('en' | 'de'). */
    locale: string;
    /** Switch the UI language and remember the choice. */
    setLocale: (locale: string) => void;
}

// Lives apart from I18nProvider so that file exports only its component (a file
// mixing the two breaks Fast Refresh — see the react-refresh lint rule).
export const LocaleContext = createContext<LocaleContextValue>({
    locale: defaultLocale,
    setLocale: () => {}
});

/** The current UI language + a way to change it (see I18nProvider). */
export function useLocale(): LocaleContextValue {
    return useContext(LocaleContext);
}
